<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <FreePerksTopOffer />
      <FreePerksCategoriesCards 
        v-on:navigate="navigate($event)" 
        :customerInfo="customerInfo"/>
      <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :freeCardsData="freeCardsData"
          :id="id"
      />
    </div>
  </b-container>
</template>

<script>
import FreePerksTopOffer from "@/components/centre/perks/free/FreePerksTopOffer.vue";
import FreePerksCategoriesCards from "@/components/centre/perks/free/FreePerksCategoriesCards.vue";
import FreePerksShowAllCards from "@/components/centre/perks/free/FreePerksShowAllCards.vue";

// import AromatherapyForTheCourageous from "@/assets/images/centre/Free/free-offers/free-expert-advice/aromatherapy-for-the-courageous.png";
import EosWithThePros from "@/assets/images/centre/Free/free-offers/free-expert-advice/EOs-with-the-Pros.png";
// import KcVision from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/Kc-What is your vision.png";
import KcProTips from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/KC-Pro-tips-on-visibility.png";
import KcIsYourBusiness from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/Kc-Is-your-business-reflecting-your-vitality.png";
import CosmEthically from "@/assets/images/centre/Free/free-offers/free-extras/CosmEthically-ACTIVE-Journal2.png";
// import Avatar1 from "@/assets/images/centre/Free/free-modal/Avatar1.png";
// import Avatar2 from "@/assets/images/centre/Free/free-modal/Avatar2.png";
// import Avatar3 from "@/assets/images/centre/Free/free-modal/Avatar3.png";
// import Avatar4 from "@/assets/images/centre/Free/free-modal/Avatar4.png";
import CosmEthicallyPopUp from "@/assets/images/centre/Free/free-modal/CosmEthicallyPopUp.png";
import GetInspiredImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Get-inspired.png";
import TinyImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Tiny-but-mighty.png";
import UnlockingImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Unlocking-the-magic.png";
import CalmingSanctuaryImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Create-your-Calming-Sanctuary.png";
import BlendingImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Blending-with-Benefits.png";
import GettingCraftyImg from "@/assets/images/centre/Free/free-offers/free-expert-advice/Getting-Crafty-with-Chemistry.png";
import WhatAreYouTalking from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/What_are_you_talking_about.png";
import IsThereAnEasy from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/Is_there_an_easy.png";
import WhatAreYourNumbers from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/What_are_your_numbers.png";
import The5Questions from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/The_5_questions.png";
import IsTheInformation from "@/assets/images/centre/Free/free-offers/free-quick-perks-courses/Is_the_information.png";


export default {
  title: "Center Perks",
  name: "Perks",
  props: ["page", "customerInfo", "id"],
  components: {
    FreePerksTopOffer,
    FreePerksCategoriesCards,
    FreePerksShowAllCards,
  },
  mounted() {
    let target = this.page ? this.page : "FreePerksShowAllCards";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // categories possible by now: ExpertAdvice / QuickPerksCourses / Extras
      freeAllCardsData: [
        /*{
          id: 1,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Aromatherapy for the curious & courageous",
          cardDescription: "by Melani Kovac",
          cardImage: AromatherapyForTheCourageous,
          cardUrl: "",
          modalTitle: "Aromatherapy for the curious & courageous",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://expo.dropsmart.io/melani/aroma-empress", //if the modal has a button link
          leftButton: "I want to learn more with Melani",
          rightButton: "",
          modalVideo: "https://player.vimeo.com/video/780814500",
          hasReview: true,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: Avatar1,
              reviewName: "Diane",
              reviewDescription: "Maharishi Aromatherapy Student",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: 'This is absolutely brilliant!!! Thank you, Melani for an amazing presentation. It was very enjoyable and a great learning experience.'
              },
              ],
            },
            {
              reviewId: 2,
              reviewImg: Avatar2,
              reviewName: "Jennifer",
              reviewDescription: "Maharishi Aromatherapy Student",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: 'Thank you so much! I love your work and use it so much, a wonderful guide and support.'
              },
              ],
            },
            {
              reviewId: 3,
              reviewImg: Avatar3,
              reviewName: "Susan",
              reviewDescription: "Maharishi Aromatherapy Student",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: 'All that you have created is so necessary and valuable for working with the allopathic field to demonstrate the validity of aromatherapy. Thank you so much for all your work and brilliance'
              },
              ],
            },
            {
              reviewId: 4,
              reviewImg: Avatar4,
              reviewName: "Akos",
              reviewDescription: "Maharishi Aromatherapy Student",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: "This has been a phenomenal experience and I can't wait to go back and watch the replay. Wonderful presentation, thank you so much for all you knowledge and your time."
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 2,
          hasModal: false,
          category: "ExpertAdvice",
          cardTitle: "EOs with the Pros",
          cardDescription: "10-day email course",
          cardImage: EosWithThePros,
          cardUrl: "https://pages.dropsmart.io/eos-with-the-pros/",
          modalTitle: "",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "", //if the modal has a button link
          leftButton: "",
          rightButton: "",
          modalVideo: "",
          hasReview: true,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },*/
        {
          id: 3,
          hasModal: false,
          category: "ExpertAdvice",
          cardTitle: "5-Day Challenge",
          cardDescription: "Join the 5-Day Essential Oil Expert Challenge!",
          cardImage: EosWithThePros,
          cardUrl: "https://pages.dropsmart.io/5-day-challenge",
          modalTitle: "",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "", //if the modal has a button link
          leftButton: "",
          rightButton: "",
          modalVideo: "",
          hasReview: true,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 4,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Is your business reflecting your vitality?",
          cardDescription: "by Kc Rossi",
          cardImage: KcIsYourBusiness, //KcProTips
          cardUrl: "",
          modalTitle: "Is your business reflecting your vitality?",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "", //if the modal has a button link
          leftButton: "",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/775746384",
          hasReview: false,
          reviews:
          [
            
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 5,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Pro tips on visibility",
          cardDescription: "by Kc Rossi",
          cardImage: KcProTips,
          cardUrl: "",
          modalTitle: "Pro tips on visibility",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "", //if the modal has a button link
          leftButton: "",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/775746779",
          hasReview: false,
          reviews:
          [
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 6,
          hasModal: true,
          category: "Extras",
          cardTitle: "Download your complimentary CosmEthically ACTIVE Journal",
          cardDescription: "",
          cardImage: CosmEthically,
          cardUrl: "",
          modalTitle: "Grab your copy of the CosmEthically ACTIVE Journal!",
          modalSubtitle: "Experience the benefits of a CosmEthically ACTIVE Journal",
          modalImage: CosmEthicallyPopUp,
          modalUrl: "https://dropsmart.io/wp-content/uploads/2024/12/CosmEthically-ACTIVE-journal-2021-2.pdf", //if the modal has a button link
          leftButton: "Download your CosmEthically ACTIVE Journal",
          rightButton: "Submit your review",
          modalVideo: "",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 7,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Unlocking the magic of essential oil synergy with Dr. E. Joy Bowles",
          cardDescription: "",
          cardImage: UnlockingImg,
          cardUrl: "",
          modalTitle: "Unlocking the magic of essential oil synergy with Dr. E. Joy Bowles",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://www.ejoybowles.com/", //if the modal has a button link
          leftButton: "Dive into learning with Joy!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/788653936",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 8,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Tiny but mighty: Understand the impact of chemical components!",
          cardDescription: "",
          cardImage: TinyImg,
          cardUrl: "",
          modalTitle: "Tiny but mighty: Understand the impact of chemical components!",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://www.ejoybowles.com/", //if the modal has a button link
          leftButton: "Dive into learning with Joy!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/788654252",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 9,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Get inspired: Exciting ideas from Joy!",
          cardDescription: "",
          cardImage: GetInspiredImg, 
          cardUrl: "",
          modalTitle: "Get inspired: Exciting ideas from Joy!",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://www.ejoybowles.com/", //if the modal has a button link
          leftButton: "Dive into learning with Joy!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/788654528",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 10,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Create your Calming Sanctuary",
          cardDescription: "",
          cardImage: CalmingSanctuaryImg,
          cardUrl: "",
          modalTitle: "Create your Calming Sanctuary: Unlocking the Power of Essential Oils",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://pages.dropsmart.io/eos-with-the-pros/", //if the modal has a button link
          leftButton: "Unlock expert insights with EO's with the Pros!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/764561269",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 11,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Blending with Benefits: Understanding Synergy in Aromatherapy",
          cardDescription: "",
          cardImage: BlendingImg,
          cardUrl: "",
          modalTitle: "Blending with Benefits: Understanding Synergy in Aromatherapy",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://pages.dropsmart.io/eos-with-the-pros", //if the modal has a button link
          leftButton: "Unlock expert insights with EO's with the Pros!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/764535023",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 12,
          hasModal: true,
          category: "ExpertAdvice",
          cardTitle: "Getting Crafty with Chemistry: Designing a Ravintsara Replacement",
          cardDescription: "",
          cardImage: GettingCraftyImg,
          cardUrl: "",
          modalTitle: "Getting Crafty with Chemistry: Designing a Ravintsara Replacement",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://pages.dropsmart.io/eos-with-the-pros/", //if the modal has a button link
          leftButton: "Unlock expert insights with EO's with the Pros!", //if the modal has a button on the left side
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/764616749",
          hasReview: false,
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 13,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "The 5 questions you should be asking about essential oils",
          cardDescription: " by Melani Kovac",
          cardImage: The5Questions,
          cardUrl: "",
          modalTitle: "The 5 questions you should be asking about essential oils",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://join.dropsmart.io/", //if the modal has a button link
          leftButton: "Don't have Dropsmart Premium yet? Click here and upgrade today!",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/815398932",
          hasReview: false,
          reviews: [],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 14,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Question #2: What are you talking about?",
          cardDescription: "by Melani Kovac",
          cardImage: WhatAreYouTalking, 
          cardUrl: "",
          modalTitle: "Question #2: What are you talking about?",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://expo.dropsmart.io/melani/aroma-alphabet", //if the modal has a button link
          leftButton: "Ready to learn more? Click here and join Aroma Alphabet course today!",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/815445507",
          hasReview: false,
          reviews: [],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 15,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Question #3: Is the information you are studying relevant?",
          cardDescription: "by Melani Kovac",
          cardImage: IsTheInformation, 
          cardUrl: "",
          modalTitle: "Question #3: Is the information you are studying relevant?",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://expo.dropsmart.io/melani/next-level-program", //if the modal has a button link
          leftButton: "Click here and join Next Level Power Drops Program today!",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/815454785",
          hasReview: false,
          reviews: [],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 16,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Question #4: What are your numbers?",
          cardDescription: "by Melani Kovac",
          cardImage: WhatAreYourNumbers,
          cardUrl: "",
          modalTitle: "Question #4: What are your numbers?",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://expo.dropsmart.io/melani/next-level-program", //if the modal has a button link
          leftButton: "Click here and join Next Level Power Drops Program today!",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/815467100",
          hasReview: false,
          reviews: [],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 17,
          hasModal: true,
          category: "QuickPerksCourses",
          cardTitle: "Question #5:  Is there an easy more professional way to determine what note is my oil?",
          cardDescription: "by Melani Kovac",
          cardImage: IsThereAnEasy,
          cardUrl: "",
          modalTitle: "Question #5:  Is there an easy more professional way to determine what note is my oil?",
          modalSubtitle: "",
          modalImage: "",
          modalUrl: "https://expo.dropsmart.io/melani/next-level-program", //if the modal has a button link
          leftButton: "Click here and join Next Level Power Drops Program today!",
          rightButton: "Submit your review",
          modalVideo: "https://player.vimeo.com/video/815401325",
          hasReview: false,
          reviews: [],
          personalBadge: 
          {
            freeBadge: "", 
          },
          personalCoupom: 
          {
            freeCoupom: '',
          },
          showOnDeck: true,
        },
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    freeCardsData() {
      return this.freeAllCardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>